module.exports = __webpack_public_path__ + "img/Interacting.4876a8c5.svg";